import { useEffect, useState } from "react";
import { api, fmtBytes, fmtNum } from "@/lib/api";
import { AlertTriangle, X } from "lucide-react";
import { cn } from "@/lib/utils";

const FMT = {
  pages: (v) => `${fmtNum(v)} pages`,
  llm_cost_usd: (v) => `$${Number(v || 0).toFixed(2)}`,
  exports: (v) => `${fmtNum(v)} exports`,
  storage_bytes: (v) => fmtBytes(v),
};

export default function QuotaBanner({ onOpenUsage }) {
  const [warnings, setWarnings] = useState([]);
  const [dismissed, setDismissed] = useState([]);

  useEffect(() => {
    const load = () => api.getUsage(1).then((d) => setWarnings(d.warnings || [])).catch(() => {});
    load();
    const t = setInterval(load, 45000);
    return () => clearInterval(t);
  }, []);

  const active = warnings.filter((w) => !dismissed.includes(w.resource));
  if (active.length === 0) return null;
  const worst = active.reduce((a, b) => (b.percent > a.percent ? b : a));
  const fmt = FMT[worst.resource] || fmtNum;

  return (
    <div data-testid="quota-banner"
      className={cn("flex flex-wrap items-center gap-2 px-4 sm:px-6 py-2.5 border-b text-xs font-mono",
        worst.exhausted
          ? "bg-rose-500/10 border-rose-500/40 text-rose-200"
          : "bg-amber-500/10 border-amber-500/40 text-amber-200")}>
      <AlertTriangle className="h-3.5 w-3.5 shrink-0" />
      <span data-testid="quota-banner-text">
        {worst.exhausted
          ? `${worst.label} quota exhausted — ${fmt(worst.used)} of ${fmt(worst.limit)} used. Crawls and AI calls are blocked until it resets.`
          : `You've used ${worst.percent}% of your monthly ${worst.label} quota (${fmt(worst.used)} of ${fmt(worst.limit)}).`}
      </span>
      {onOpenUsage && (
        <button data-testid="quota-banner-open-usage" onClick={onOpenUsage}
          className="underline underline-offset-2 hover:no-underline">
          view usage &amp; plans
        </button>
      )}
      <button data-testid="quota-banner-dismiss" onClick={() => setDismissed((d) => [...d, worst.resource])}
        className="ml-auto opacity-60 hover:opacity-100 transition-opacity"><X className="h-3.5 w-3.5" /></button>
    </div>
  );
}
